
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ObjectExpansionEditor extends Vue {
  @Prop() dataSource!: ObjectDataSource;
  @Prop() propertiesOverrideInfo: any;
  @Prop() propertyGroupsOverrideInfo: any;
  @Prop() parentId?: number;

  get groups(): Array<any> {
    return this.dataSource?.metadata?.groups ?? [];
  }

  // «Отзывы» хранятся в таблице, которой на проектах нет: редактор на каждой
  // карточке дёргает несуществующий адрес и получает 404 (четырнадцать раз за
  // двое суток на lorlor). Поле ничего не показывает и ничего не сохраняет —
  // убираем из карточки.
  static readonly HIDDEN_EDITORS = ["linkedreview"];

  filterProperties(group) {
    const properties = this.dataSource?.metadata?.properties;
    return !(properties?.length > 0)
      ? []
      : properties.filter(
          (p: any) =>
            p.group === group.name &&
            !ObjectExpansionEditor.HIDDEN_EDITORS.includes(String(p.editor ?? "").toLowerCase()),
        );
  }

  created() {
    this.overrideProperties();
    this.overridePropertyGroups();
  }

  overrideProperties() {
    if (!this.propertiesOverrideInfo) return;
    const properties = this.dataSource?.metadata?.properties;
    for (const property of properties) {
      for (const propertyOverrideInfo of this.propertiesOverrideInfo) {
        if (property.name != propertyOverrideInfo.name) continue;
        Object.assign(property, propertyOverrideInfo);
      }
    }
  }
  overridePropertyGroups() {
    if (!this.propertyGroupsOverrideInfo) return;
    const groups = this.dataSource?.metadata?.groups;
    for (const group of groups) {
      for (const groupOverrideInfo of this.propertyGroupsOverrideInfo) {
        if (group.name != groupOverrideInfo.name) continue;
        Object.assign(group, groupOverrideInfo);
      }
    }
  }
}
